import React from 'react';
import { TREATMENT_TYPES } from '../utils/data';

const STATUS_CONFIG = {
  'Overdue':   { bg: '#FEF0EF', color: '#C0392B', border: '#F5C6C2' },
  'Due Soon':  { bg: '#FEF6EE', color: '#E67E22', border: '#F9D5AE' },
  'Upcoming':  { bg: '#F0F7F6', color: '#2D9B8A', border: '#B5DED9' },
  'Contacted': { bg: '#F0F3F8', color: '#1B2B4B', border: '#B8C5D9' },
};

export function StatusBadge({ status }) {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG['Upcoming'];
  return (
    <span style={{
      display: 'inline-block',
      padding: '3px 8px',
      fontSize: 11,
      fontWeight: 700,
      fontFamily: "'JetBrains Mono', monospace",
      letterSpacing: '0.5px',
      textTransform: 'uppercase',
      background: cfg.bg,
      color: cfg.color,
      border: `1px solid ${cfg.border}`,
      borderRadius: 2,
      whiteSpace: 'nowrap',
    }}>
      {status}
    </span>
  );
}

export function TreatmentPill({ type }) {
  const cfg = TREATMENT_TYPES[type] || { color: '#7F8C8D', label: type };
  return (
    <span style={{
      display: 'inline-block',
      padding: '3px 8px',
      fontSize: 11,
      fontWeight: 600,
      fontFamily: "'JetBrains Mono', monospace",
      color: cfg.color,
      background: cfg.color + '18',
      border: `1px solid ${cfg.color}40`,
      borderRadius: 2,
      whiteSpace: 'nowrap',
      maxWidth: 130,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }}>
      {type}
    </span>
  );
}
